import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import JoinVideoCallDialog from '../pages/dialogs/JoinVideoCallDialog/JoinVideoCallDialog'
import NoServiceDialog from '../pages/dialogs/NoServiceDialog/NoServiceDialog'
import SomethingWentWrongDialog from '../pages/dialogs/SomethingWentWrongDialog/SomethingWentWrongDialog'
import TerminateBotDialog from '../pages/dialogs/TerminateBotDialog'
import SideMenu from './SideMenu'
import Header from './Header'
import { ConfigProvider, Spin, Layout } from 'antd'
import GeneralMessage from '../common/GeneralMessage'
import DismissibleSiteBanner from '../common/DismissibleSiteBanner'
import TimeSlotExpireDialog from '../pages/dialogs/TimeSlotExpireDialog'
import ApprovePaymentDialog from '../pages/dialogs/ApprovePaymentDialog'
import RiskAssessmentExitDialog from '../pages/dialogs/RiskAssessmentExitDialog'
import SignUpErrorDialog from '../pages/dialogs/SignUpErrorDialog/SignUpErrorDialog'
import HmoPolicyConcentDialog from '../pages/dialogs/HmoPolicyConcentDialog'

import './MainLayout.css'

export const MainLayout = ({ children }) => {
  const mainLayoutRef = useRef()
  const currentRouteLocation = useSelector(
    state => state.router.location.pathname
  )
  const { isLoggedIn } = useSelector(state => state.auth)
  const { is_test } = useSelector(state => state.profile.userDetails || {})
  const isCallActive = useSelector(state => state.videoCall.isCallActive)
  const { isUserDetailsLoading, isCommunicationPreferencesConfigureMode } =
    useSelector(state => state.profile)
  const isExternalPlanPage = currentRouteLocation.includes('payment-plans-form')
  const isProvidersPage = currentRouteLocation.includes('providers')
  const isOnPreferenceConfiguePage =
    currentRouteLocation.includes('communication-preferences') &&
    !isCommunicationPreferencesConfigureMode
  const isOnBoardingPage =
    currentRouteLocation.includes('secret-questions') ||
    isOnPreferenceConfiguePage
  const isBillingPage = currentRouteLocation.includes('billing')

  const renderTestUserBar = () => {
    if (!is_test) return null
    return <Layout.Header className="test-user-header">Test User</Layout.Header>
  }

  const renderHome = () => {
    return isUserDetailsLoading ? <Spin size="large" /> : children
  }

  const renderLoggedInContent = () => {
    return (
      <>
        {renderTestUserBar()}
        
        <DismissibleSiteBanner />
        <div className="main-layout">
          {!isExternalPlanPage &&
            !isCallActive &&
            !isOnBoardingPage &&
            !isUserDetailsLoading && (
              <div className="menu">
                <SideMenu />
              </div>
            )}
          <div
            ref={mainLayoutRef}
            key="main-layout"
            id="mainLayoutContainer"
            className={`main-layout-body grey ${
              (isExternalPlanPage || isOnBoardingPage) &&
              'remove-main-layout-margin'
            }`}
          >
            {isExternalPlanPage || isOnBoardingPage ? children : renderHome()}
          </div>
          <JoinVideoCallDialog />
          <NoServiceDialog />
          <SomethingWentWrongDialog />
          <ConfigProvider
            getPopupContainer={() =>
              document.getElementById('mainLayoutContainer')
            }
          >
            <GeneralMessage />
          </ConfigProvider>

          <TerminateBotDialog />
          <RiskAssessmentExitDialog />
          <TimeSlotExpireDialog />
          <ApprovePaymentDialog />
          <HmoPolicyConcentDialog />
        </div>
      </>
    )
  }

  const renderLoggedOutContent = () => {
    return (
      <>
        {renderTestUserBar()}
        {!isExternalPlanPage && !isProvidersPage && (
          <Header key="header" isLogoClickable={!isBillingPage} />
        )}
        <div
          key="main-layout"
          className={
            isProvidersPage || isOnBoardingPage
              ? 'main-layout-body grey'
              : 'main-layout-body'
          }
        >
          {children}
        </div>
        <SignUpErrorDialog />
        <HmoPolicyConcentDialog />
      </>
    )
  }

  return isLoggedIn && !isExternalPlanPage && !isOnBoardingPage
    ? renderLoggedInContent()
    : renderLoggedOutContent()
}

export default MainLayout
